import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './component/Home';
import About from './component/About';
import Contact from './component/Contact';
import Header from './component/Header';
import Footer from './component/Footer';
import NavbarTop from './component/NavbarTop';
import NavbarBottom from './component/NavbarBottom';
import LandingPage from './component/LandingPage';
import ProductAll from './component/ProductAll';
import Blog from './component/Blog';
import DetailBlog from './component/DetailBlog';
import DetailProduct from './component/DetailProduct';
import Login from './component/Login';
import Dashboard from './component/Dashboard';
import ProductSearch from './component/ProductSearch';
import BtnMsg from './component/BtnMsg';
import WhereToBuy from './component/WhereToBuy';
import SuccessReg from './component/SuccessReg';
import ProductByJenis from './component/ProductByJenis';

function App() {
  return (
    <Router>
      <div className="max-w-12xl mx-auto">        
        <NavbarTop />
        <NavbarBottom />
        <main className="p-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/landingpage" element={<LandingPage />} />
            <Route path="/allproduct" element={<ProductAll />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/detailblog/:id" element={<DetailBlog />} />
            <Route path="/detailproduct/:id" element={<DetailProduct />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/searchpage" element={<ProductSearch />} />
            <Route path="/wheretobuy" element={<WhereToBuy />} />
            <Route path="/successreg" element={<SuccessReg />} />
            <Route path="/product/:id" element={<ProductByJenis />} />
          </Routes>
        </main>
        <BtnMsg />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
